var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "card" }, [
      _c(
        "div",
        {
          staticClass: "row",
          staticStyle: { display: "flex", flex: "1 1 auto" },
        },
        [
          _c("div", { staticClass: "col-12 col-md-6" }, [
            _c("div", { staticClass: "img-square-wrapper" }, [
              _c("img", {
                class:
                  "card-img img-fluid m-05 product-image-" + _vm.product.id,
                attrs: {
                  src:
                    _vm.product.product_image.length > 0
                      ? _vm.product.product_image[0].url
                      : "/images/cover.png",
                  alt: "Product Image",
                },
              }),
              _vm._v(" "),
              _vm.product.product_image.length > 1
                ? _c(
                    "span",
                    _vm._l(_vm.product.product_image, function (image) {
                      return _c("span", { staticClass: "ml-05 mb-2" }, [
                        _c(
                          "a",
                          {
                            on: {
                              click: function ($event) {
                                $event.preventDefault()
                                return _vm.changeImage(
                                  _vm.product.id,
                                  image.url
                                )
                              },
                            },
                          },
                          [
                            _c("img", {
                              staticClass: "rounded",
                              attrs: {
                                src: image.url,
                                height: "50",
                                width: "50",
                                alt: "Product Image",
                              },
                            }),
                          ]
                        ),
                      ])
                    }),
                    0
                  )
                : _vm._e(),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-12 col-md-6" }, [
            _c("div", { staticClass: "card-body p-1" }, [
              _c("h4", {
                staticClass: "font-large-2",
                domProps: { textContent: _vm._s(_vm.product.title) },
              }),
              _vm._v(" "),
              _vm.product.average_rating !== null
                ? _c("div", { staticClass: "mt-05 mb-05" }, [
                    _c("span", {
                      class:
                        "rating-static rating-" +
                        _vm.product.average_rating * 10,
                    }),
                  ])
                : _vm._e(),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "card-text p-1 border-bottom breakAll" }, [
              _c("span", {
                staticClass: "breakAll image-resize",
                domProps: {
                  innerHTML: _vm._s(_vm.product.product_description),
                },
              }),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "d-flex p-1 align-items-center border-bottom" },
              [
                _c("div", { staticClass: "ml-auto pr-1" }, [
                  _c(
                    "a",
                    {
                      attrs: {
                        "data-toggle": "modal",
                        "data-target": "#registerModal",
                      },
                    },
                    [
                      _c(
                        "button",
                        {
                          staticClass:
                            "btn btn-primary waves-effect waves-light",
                        },
                        [
                          _vm._v(
                            "\n                                " +
                              _vm._s(_vm.__("globals.buy_now")) +
                              " "
                          ),
                          _c("i", { staticClass: "fa fa-tag" }),
                        ]
                      ),
                    ]
                  ),
                ]),
              ]
            ),
            _vm._v(" "),
            _c(
              "a",
              {
                staticStyle: { color: "inherit" },
                attrs: {
                  href: "#",
                  "data-toggle": "modal",
                  "data-target": "#registerModal",
                },
              },
              [
                _c("post-owner-info", {
                  attrs: { user_data: _vm.product.owner, time: null },
                }),
              ],
              1
            ),
          ]),
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass:
            "d-flex justify-content-between border-top pr-05 pl-05 mt-1",
        },
        [
          _c("div", { staticClass: "p-05" }, [
            _c("i", {
              staticClass: "fa fa-thumbs-o-up",
              attrs: {
                "data-toggle": "modal",
                "data-target": "#registerModal",
              },
            }),
            _vm._v(
              " " +
                _vm._s(_vm.product.likes === 0 ? "" : _vm.product.likes) +
                "\n            "
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "p-05" }, [
            _c(
              "span",
              {
                attrs: {
                  "data-toggle": "modal",
                  "data-target": "#registerModal",
                },
              },
              [
                _c("i", { staticClass: "fa fa-comment-o" }),
                _vm._v(
                  " " +
                    _vm._s(
                      _vm.product.comments === 0 ? "" : _vm.product.comments
                    ) +
                    " " +
                    _vm._s(
                      _vm.product.comments === 1
                        ? _vm.__("globals.comment")
                        : _vm.__("globals.comments")
                    ) +
                    "\n                "
                ),
              ]
            ),
          ]),
          _vm._v(" "),
          _c(
            "div",
            [
              _c("guest-social-share", {
                attrs: { social: _vm.product.social_share },
              }),
            ],
            1
          ),
        ]
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }